import { CSSProperties } from 'react';
import styled from 'styled-components';

export { FieldLabel, Label } from './Label';

export const getFieldWrapStyle = (error?: boolean, style?: CSSProperties): CSSProperties => ({
  border: error ? '1px solid var(--red-100)' : 'none',
  outline: 'none',
  borderRadius: 16,
  background: 'var(--black-5)',
  fontSize: 18,
  lineHeight: '24px',
  padding: 16,
  color: 'var(--font-color)',
  ...style,
});

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;
